<template>
  <div class="mainContainer">
    <div class="mainContainer-container">
      <div class="mainContainer-container-rightBox">
        <div class="mainContainer-container-rightBox-content">
          <Card v-for="(item, index) in categoryArray"
                :key="index"
                :spu="item"></Card>
          <a-empty v-if="categoryArray.length == 0 && !spinState"></a-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue"
import { useRoute } from "vue-router"
import type { categoriesDetailState } from "../../shop/api/interface/categoriesInterface"
import Card from "../../shop/view/CategoriesCardPage.vue"
import { getCouponProductsList } from '../api/couponProducts'
const route = useRoute()
// initialize Startup
onMounted(() => {
  init()
})
const init = () => {
  const couponId = route.params.id
  spinState.value = true
  categoryArray.length = 0
  getCouponProductsList(couponId as any).then((result: any) => {
    categoryArray.push(...result.rows)
    spinState.value = false
  })
}

// declare Type
const spinState = ref<boolean>(false)
const categoryArray = reactive<Array<categoriesDetailState>>([])
</script>

<style lang="less" scoped>
.mainContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  &-container {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-end;
    overflow: auto;

    &-leftBox {
      width: 100%;
      padding: 10px 0;
      overflow: hidden;
      overflow-y: auto;

      .ant-menu-horizontal {
        border-bottom: none;
      }

      .menu {
        :deep(.ant-menu-item-selected) {
          background: #111111 !important;
          color: #ffffff;
        }

        :deep(.ant-menu-item-active) {
          border: 1px solid #111111 !important;
        }

        :deep(.ant-menu-item-selected::after) {
          border: 1px solid #111111 !important;
        }

        :deep(.ant-menu-item-active::after) {
          border: 1px solid #111111 !important;
          display: none;
        }

        :deep(.ant-menu-item) {
          margin: 5px 5px 5px 5px;
          border: 1px solid #f1f1f1;
          width: 98px;
          text-align: center;
        }

        :deep(.ant-menu-item:first-child) {
          margin-left: 25px;
        }
      }
    }

    &-rightBox {
      flex: 1;
      width: 100%;
      overflow: hidden;
      overflow-y: auto;

      &-title {
        width: 100%;
        height: 40px;

        &-text {
          font-size: 20px;
          margin-left: 20px;
          margin-top: 5px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 28px;
        }
      }

      &-content {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
        align-items: center;

        .ant-empty {
          margin-top: 30px;
        }

        .ant-spin {
          margin-top: 50px;
        }
      }
    }
  }
}

:deep(.ant-spin-container) {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
}

:deep(.ant-menu-item-selected) {
  background-color: #fff !important;
}

:deep(.activeItem) {
  background-color: #111111 !important;
  color: #ffffff;
}
</style>
